
import { mapState, mapMutations } from "vuex";
import { Medias } from "@/graphql/medias";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/media-kits",
      "fr-ca": "/trousses-medias",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const mediasResponse = await client.query({
      query: Medias,
      variables: { locale: locale },
    });
    const troussesMedia = mediasResponse.data.trousseMedia.data.attributes;

    return { troussesMedia };
  },
  data() {
    return {
      troussesMedia: {},
      show: false,
      anchorSelected: "",
    };
  },
  head() {
    return {
      title: this.troussesMedia.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.troussesMedia.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.troussesMedia.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          90 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
